// extracted by mini-css-extract-plugin
export var card = "card-expanded-module--card--fwRP2";